import { takeLatest, call, put } from "redux-saga/effects";
import { REGION_PAGE_LOAD, regionPageLoaded } from "../../actions/regions";
import getRegion from "../../../../../backend/oncall/partners/regions/get-by-id";
import { showErrorPage } from "../../../../../actions/ui/location";

const regionPageLoadSaga = function*(action) {
  try {
    if (action.payload.regionId === undefined) {
      // These are the default values on the add page.
      yield put(
        regionPageLoaded({
          name: "",
          administrative: false,
          defaultShiftChangeTime: "00:00:00",
          defaultShiftDays: "7",
          enabled: true,
          timeZone: "",
          emails: [],
        }),
      );
      return;
    }
    const result = yield call(getRegion, action.payload.regionId);
    yield put(regionPageLoaded(result));
  } catch (ignore) {
    yield put(showErrorPage());
  }
};

export default function*() {
  //noinspection JSCheckFunctionSignatures
  yield takeLatest(REGION_PAGE_LOAD, regionPageLoadSaga);
}



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/sagas/regions/edit-page-load.js